/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicCustomWorkflowManager extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicCustomWorkflowManager");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicCustomWorkflowManager.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicCustomWorkflowManager>): BackgroundJobPayloadForPeriodicCustomWorkflowManager {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicCustomWorkflowManager(), model);
        BackgroundJobPayloadForPeriodicCustomWorkflowManager.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicCustomWorkflowManager>): BackgroundJobPayloadForPeriodicCustomWorkflowManager {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicCustomWorkflowManager.newInstance(<BackgroundJobPayloadForPeriodicCustomWorkflowManager> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicCustomWorkflowManager) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicCustomWorkflowManager.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicCustomWorkflowManager): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicCustomWorkflowManager.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
